export const defaultLocale = 'uz';

export const locales = [
    { code: 'uz', label: 'O‘z' },
    { code: 'ru', label: 'Ру' },
    { code: 'en', label: 'En' },
];

export const translations = {
    uz: {
        landing: {
            nav: {
                logoSubtitle: "Raqamli didaktika va o'quv analitikasi",
                login: 'Kirish',
                register: "Ro'yxatdan o'tish",
            },
            hero: {
                badge: "Adaptiv raqamli ta'lim ekotizimi (LMS)",
                title: [
                    "Informatikaning nazariy asoslari fanini",
                    " o'qitishda ",
                    "adaptiv raqamli ta'lim ekotizimi",
                ],
                description:
                    "Talabalarning kognitiv mustaqilligini rivojlantirishga qaratilgan innovatsion didaktik platforma. Tizim ADDIE modeli, kognitiv ergonomika va o'quv analitikasi (Learning Analytics) algoritmlari asosida loyihalashtirilgan.",
                ctaStart: 'Bepul boshlang →',
                ctaCatalog: "Kurslarni ko'rish",
            },
            modules: {
                badge: 'INA fani modullari',
                title: "Informatikaning nazariy asoslari",
                subtitle:
                    "Dissertatsiya tadqiqotlari doirasida ishlab chiqilgan eng muraqqab uchta ilmiy modul. Har bir modul adaptiv trenajyorlar va interaktiv konstruktorlar bilan jihozlangan.",
                items: [
                    {
                        title: 'Sanoq tizimlari',
                        subtitle: "Raqamli konverter-trenajyorlar",
                        desc: "2-lik, 8-lik, 10-lik va 16-lik sanoq tizimlari o'rtasida o'zaro konvertatsiya. Interaktiv trenajyorlar orqali kognitiv mustahkamlash.",
                        topics: ["2-lik → 10-lik", "16-lik → 2-lik", "Kognitiv test"],
                    },
                    {
                        title: 'Shannon-Fano algoritmi',
                        subtitle: "Dinamik chegaralash modeli",
                        desc: "Ma'lumotlarni siqish algoritmlarining nazariy asoslari. Dinamik chegaralash orqali optimal kodlash daraxtini qurish.",
                        topics: ['Ehtimollik taqsimoti', 'Chegaralash algoritmi', 'Optimal kodlash'],
                    },
                    {
                        title: 'Huffman kodi',
                        subtitle: 'Ierarxik grafik daraxt konstruktori',
                        desc: "Greedy algoritm asosida Huffman daraxtini vizual qurish. Ierarxik grafik modellar va dinamik simulyatsiyalar.",
                        topics: ['Greedy algoritm', 'Daraxt konstruktori', 'Vizual simulyatsiya'],
                    },
                ],
            },
            flipped: {
                badge: 'Flipped Classroom (Aylanma sinf) modeli',
                title: "Aylanma sinf pedagogikasi",
                subtitle:
                    "Tizim Bloom taksonomiyasi va aylanma sinf konsepsiyasi asosida ishlaydi. Nazariy bilimlar auditoriyadan tashqari, amaliy ko'nikmalar esa sinf jarayonida shakllantiriladi.",
                items: [
                    {
                        phase: "Asinxron ta'lim",
                        title: 'Auditoriyadan tashqari',
                        desc: "Kognitiv video-ma'ruzalar va intellekt-xaritalar bilan mustaqil tanishish. Talabalar o'z sur'atida nazariy bilimlarni qamrab oladi.",
                        tags: ["Video-ma'ruzalar", 'Intellekt-xaritalar', "Mustaqil o'qish"],
                    },
                    {
                        phase: "Sinxron ta'lim",
                        title: 'Auditoriyada',
                        desc: "JavaScript asosidagi virtual trenajyorlar, Shennon va Xaffman konstruktorlarida amaliy ko'nikmalarni rivojlantirish.",
                        tags: ['Virtual trenajyorlar', 'Algoritm konstruktori', "Amaliy mashg'ulot"],
                    },
                ],
            },
            stats: [
                { label: "Aktiv talabalar", value: '120+' },
                { label: 'Asinxron monitoring', value: '24/7' },
                { label: "Ilmiy modul", value: '3+' },
                { label: "Kognitiv o'sish", value: '98%' },
                { label: "Video ma'ruza", value: '45+' },
                { label: 'Virtual trenajyor', value: '12' },
                { label: "Analitik ko'rsatkich", value: '15+' },
                { label: 'Sertifikatlangan', value: '85+' },
            ],
            features: [
                { title: "Sun'iy intellekt", desc: "AI yordamida ochiq javoblarni avtomatik tekshirish va kognitiv maslahatlar berish tizimi" },
                { title: "Adaptiv ta'lim", desc: "Har bir talabaning metakognitiv darajasiga moslashtirilgan shaxsiy ta'lim yo'li" },
                { title: "Video darsliklar", desc: "HLS formatida yuqori sifatli kognitiv video darslar va onlayn ko'rish imkoniyati" },
                { title: "Fayl boshqaruvi", desc: "PDF, PPTX, DOCX, XLSX fayllarni yuklash va platformada interaktiv ko'rish" },
                { title: 'Interaktiv testlar', desc: "Ko'p turdagi testlar: tanlash, to'g'ri/noto'g'ri, ochiq javob va AI tekshiruvi" },
                { title: 'Geymifikatsiya', desc: "XP ballar, yutuqlar, sertifikatlar va reyting tizimi orqali motivatsiyani oshirish" },
                { title: 'Learning Analytics', desc: "O'qituvchi va talaba uchun batafsil o'quv analitikasi va tahlil paneli" },
                { title: 'Muhokamalar', desc: "Kurs bo'yicha ilmiy muhokama va savol-javob forumi" },
                { title: "Darslarni boshqarish", desc: "Drag-and-drop orqali darslar tartibini o'zgartirish va Excel import" },
                { title: 'Dark/Light rejim', desc: "Kognitiv ergonomika asosida kunduzgi va tungi rejimlar o'rtasida qulay almashish" },
                { title: 'Xavfsizlik', desc: "Foydalanuvchi rollari, autentifikatsiya va ilmiy ma'lumotlar himoyasi" },
                { title: "Qulay interfeys", desc: "Zamonaviy va mobil qurilmalarga moslashgan adaptiv dizayn" },
            ],
            featuresTitle: 'Platforma imkoniyatlari',
            featuresSubtitle: "Dissertatsiya tadqiqotlari asosida ishlab chiqilgan innovatsion ta'lim vositalari",
            methodology: {
                title: "Ta'lim metodikasi",
                cards: [
                    {
                        title: 'Model va tarkib',
                        desc: "Elektron o'quv resurslarini ishlab chiqish va qo'llash asosida ta'lim jarayonini takomillashtirish metodikasining model va tarkibiy tuzilishi",
                    },
                    {
                        title: 'Shakl va vositalar',
                        desc: "Elektron o'quv resurslarini qo'llash asosida ta'lim jarayonini takomillashtirishning shakllari, usullari, vositalari va bosqichlari",
                    },
                    {
                        title: 'Pedagogik shart',
                        desc: "Raqamli ta'lim muhitida takomillashtirilgan ta'limni amalga oshirishning pedagogik shart-sharoitlari va metodik ta'minoti",
                    },
                ],
            },
            cta: {
                title: 'Ilmiy tadqiqotda ishtirok eting!',
                desc: "SmartEduLab platformasida adaptiv raqamli ta'lim ekotizimini sinab ko'ring va kognitiv mustaqilligingizni rivojlantiring",
                button: "Ro'yxatdan o'tish →",
            },
            footer: {
                copyright: "© 2026 SmartEduLab — Adaptiv raqamli ta‘lim ekotizimi (LMS)",
                subtitle: 'ADDIE modeli, kognitiv ergonomika va Learning Analytics asosida',
            },
        },
    },
    ru: {
        landing: {
            nav: {
                logoSubtitle: 'Цифровая дидактика и учебная аналитика',
                login: 'Вход',
                register: 'Регистрация',
            },
            hero: {
                badge: 'Адаптивная цифровая образовательная экосистема (LMS)',
                title: [
                    'Адаптивная цифровая образовательная экосистема',
                    ' для преподавания ',
                    'теоретических основ информатики',
                ],
                description:
                    'Инновационная дидактическая платформа, направленная на развитие когнитивной самостоятельности студентов. Система разработана на основе модели ADDIE, когнитивной эргономики и алгоритмов обучающей аналитики (Learning Analytics).',
                ctaStart: 'Начать бесплатно →',
                ctaCatalog: 'Смотреть курсы',
            },
            modules: {
                badge: 'Модули дисциплины ТОИ',
                title: 'Теоретические основы информатики',
                subtitle:
                    'Три научных модуля, разработанных в рамках диссертационного исследования. Каждый модуль оснащен адаптивными тренажерами и интерактивными конструкторами.',
                items: [
                    {
                        title: 'Системы счисления',
                        subtitle: 'Цифровые конвертеры-тренажеры',
                        desc: 'Взаимная конвертация между двоичной, восьмеричной, десятичной и шестнадцатеричной системами счисления. Когнитивное закрепление через интерактивные тренажеры.',
                        topics: ['2-я → 10-я', '16-я → 2-я', 'Когнитивный тест'],
                    },
                    {
                        title: 'Алгоритм Шеннона-Фано',
                        subtitle: 'Модель динамического разбиения',
                        desc: 'Теоретические основы алгоритмов сжатия данных. Построение оптимального дерева кодирования через динамическое разбиение.',
                        topics: ['Распределение вероятностей', 'Алгоритм разбиения', 'Оптимальное кодирование'],
                    },
                    {
                        title: 'Код Хаффмана',
                        subtitle: 'Иерархический графический конструктор дерева',
                        desc: 'Визуальное построение дерева Хаффмана на основе жадного алгоритма. Иерархические графические модели и динамические симуляции.',
                        topics: ['Жадный алгоритм', 'Конструктор дерева', 'Визуальная симуляция'],
                    },
                ],
            },
            flipped: {
                badge: 'Модель Flipped Classroom (перевернутый класс)',
                title: 'Педагогика перевернутого класса',
                subtitle:
                    'Система работает на основе таксономии Блума и концепции перевернутого класса. Теоретические знания — вне аудитории, практические навыки — на занятии.',
                items: [
                    {
                        phase: 'Асинхронное обучение',
                        title: 'Вне аудитории',
                        desc: 'Самостоятельное знакомство с когнитивными видео-лекциями и интеллект-картами. Студенты осваивают теоретические знания в своем темпе.',
                        tags: ['Видео-лекции', 'Интеллект-карты', 'Самостоятельное обучение'],
                    },
                    {
                        phase: 'Синхронное обучение',
                        title: 'В аудитории',
                        desc: 'Развитие практических навыков на виртуальных тренажерах на основе JavaScript, в конструкторах Шеннона и Хаффмана.',
                        tags: ['Виртуальные тренажеры', 'Конструкторы алгоритмов', 'Практические занятия'],
                    },
                ],
            },
            stats: [
                { label: 'Активные студенты', value: '120+' },
                { label: 'Асинхронный мониторинг', value: '24/7' },
                { label: 'Научных модулей', value: '3+' },
                { label: 'Когнитивный рост', value: '98%' },
                { label: 'Видео лекций', value: '45+' },
                { label: 'Виртуальных тренажеров', value: '12' },
                { label: 'Аналитических показателей', value: '15+' },
                { label: 'Сертифицировано', value: '85+' },
            ],
            features: [
                { title: 'Искусственный интеллект', desc: 'Система автоматической проверки открытых ответов и когнитивных рекомендаций с помощью ИИ' },
                { title: 'Адаптивное обучение', desc: 'Индивидуальная образовательная траектория, адаптированная под метакогнитивный уровень каждого студента' },
                { title: 'Видеоуроки', desc: 'Когнитивные видеоуроки высокого качества в формате HLS с возможностью онлайн-просмотра' },
                { title: 'Управление файлами', desc: 'Загрузка и интерактивный просмотр PDF, PPTX, DOCX, XLSX файлов на платформе' },
                { title: 'Интерактивные тесты', desc: 'Разнообразные тесты: выбор, верно/неверно, открытый ответ и проверка ИИ' },
                { title: 'Геймификация', desc: 'Повышение мотивации через XP баллы, достижения, сертификаты и рейтинг' },
                { title: 'Learning Analytics', desc: 'Подробная учебная аналитика и панель анализа для преподавателя и студента' },
                { title: 'Обсуждения', desc: 'Научное обсуждение по курсу и форум вопросов-ответов' },
                { title: 'Управление уроками', desc: 'Изменение порядка уроков drag-and-drop и импорт из Excel' },
                { title: 'Темная/светлая тема', desc: 'Удобное переключение между дневным и ночным режимами на основе когнитивной эргономики' },
                { title: 'Безопасность', desc: 'Роли пользователей, аутентификация и защита научных данных' },
                { title: 'Удобный интерфейс', desc: 'Современный адаптивный дизайн для мобильных устройств' },
            ],
            featuresTitle: 'Возможности платформы',
            featuresSubtitle: 'Инновационные образовательные инструменты, разработанные в рамках диссертационного исследования',
            methodology: {
                title: 'Методика обучения',
                cards: [
                    {
                        title: 'Модель и структура',
                        desc: 'Модель и структурная организация методики совершенствования образовательного процесса на основе разработки и применения электронных образовательных ресурсов',
                    },
                    {
                        title: 'Формы и средства',
                        desc: 'Формы, методы, средства и этапы совершенствования образовательного процесса на основе применения электронных образовательных ресурсов',
                    },
                    {
                        title: 'Педагогические условия',
                        desc: 'Педагогические условия и методическое обеспечение реализации совершенствованного обучения в цифровой образовательной среде',
                    },
                ],
            },
            cta: {
                title: 'Примите участие в научном исследовании!',
                desc: 'Попробуйте адаптивную цифровую образовательную экосистему на платформе SmartEduLab и развивайте свою когнитивную самостоятельность',
                button: 'Зарегистрироваться →',
            },
            footer: {
                copyright: '© 2026 SmartEduLab — Адаптивная цифровая образовательная экосистема (LMS)',
                subtitle: 'На основе модели ADDIE, когнитивной эргономики и Learning Analytics',
            },
        },
    },
    en: {
        landing: {
            nav: {
                logoSubtitle: 'Digital didactics and learning analytics',
                login: 'Login',
                register: 'Register',
            },
            hero: {
                badge: 'Adaptive digital learning ecosystem (LMS)',
                title: [
                    'An adaptive digital learning ecosystem',
                    ' for teaching ',
                    'Theoretical Foundations of Informatics',
                ],
                description:
                    "An innovative didactic platform aimed at developing students' cognitive independence. The system is designed based on the ADDIE model, cognitive ergonomics and Learning Analytics algorithms.",
                ctaStart: 'Start for free →',
                ctaCatalog: 'Browse courses',
            },
            modules: {
                badge: 'INA subject modules',
                title: 'Theoretical Foundations of Informatics',
                subtitle:
                    'Three scientific modules developed within the dissertation research. Each module is equipped with adaptive trainers and interactive constructors.',
                items: [
                    {
                        title: 'Number systems',
                        subtitle: 'Digital converter-trainers',
                        desc: 'Mutual conversion between binary, octal, decimal and hexadecimal number systems. Cognitive reinforcement through interactive trainers.',
                        topics: ['Binary → Decimal', 'Hex → Binary', 'Cognitive test'],
                    },
                    {
                        title: 'Shannon-Fano algorithm',
                        subtitle: 'Dynamic partitioning model',
                        desc: 'Theoretical foundations of data compression algorithms. Building an optimal coding tree through dynamic partitioning.',
                        topics: ['Probability distribution', 'Partitioning algorithm', 'Optimal coding'],
                    },
                    {
                        title: 'Huffman coding',
                        subtitle: 'Hierarchical graph tree constructor',
                        desc: 'Visual construction of the Huffman tree based on a greedy algorithm. Hierarchical graph models and dynamic simulations.',
                        topics: ['Greedy algorithm', 'Tree constructor', 'Visual simulation'],
                    },
                ],
            },
            flipped: {
                badge: 'Flipped Classroom model',
                title: 'Flipped classroom pedagogy',
                subtitle:
                    "The system is based on Bloom's taxonomy and the flipped classroom concept. Theoretical knowledge is acquired outside the classroom, practical skills are formed during class.",
                items: [
                    {
                        phase: 'Asynchronous learning',
                        title: 'Outside the classroom',
                        desc: 'Independent familiarization with cognitive video lectures and mind maps. Students master theoretical knowledge at their own pace.',
                        tags: ['Video lectures', 'Mind maps', 'Self-study'],
                    },
                    {
                        phase: 'Synchronous learning',
                        title: 'In the classroom',
                        desc: 'Developing practical skills with JavaScript-based virtual trainers, in Shannon and Huffman constructors.',
                        tags: ['Virtual trainers', 'Algorithm constructors', 'Practical exercises'],
                    },
                ],
            },
            stats: [
                { label: 'Active students', value: '120+' },
                { label: 'Asynchronous monitoring', value: '24/7' },
                { label: 'Scientific modules', value: '3+' },
                { label: 'Cognitive growth', value: '98%' },
                { label: 'Video lectures', value: '45+' },
                { label: 'Virtual simulators', value: '12' },
                { label: 'Analytics metrics', value: '15+' },
                { label: 'Certified', value: '85+' },
            ],
            features: [
                { title: 'Artificial Intelligence', desc: 'AI-assisted automatic open-answer checking and cognitive recommendations' },
                { title: 'Adaptive Learning', desc: 'Personalized learning path tailored to each student\'s metacognitive level' },
                { title: 'Video Lessons', desc: 'High-quality cognitive video lessons in HLS format with online viewing' },
                { title: 'File Management', desc: 'Upload and interactively view PDF, PPTX, DOCX, XLSX files on the platform' },
                { title: 'Interactive Tests', desc: 'Multiple test types: multiple choice, true/false, open answer and AI checking' },
                { title: 'Gamification', desc: 'Motivation through XP points, achievements, certificates and leaderboard' },
                { title: 'Learning Analytics', desc: 'Detailed learning analytics and analysis dashboard for teachers and students' },
                { title: 'Discussions', desc: 'Course-based scientific discussion and Q&A forum' },
                { title: 'Lesson Management', desc: 'Reorder lessons via drag-and-drop and Excel import' },
                { title: 'Dark/Light Mode', desc: 'Comfortable switching between day and night modes based on cognitive ergonomics' },
                { title: 'Security', desc: 'User roles, authentication and protection of scientific data' },
                { title: 'User-friendly Interface', desc: 'Modern adaptive design for mobile devices' },
            ],
            featuresTitle: 'Platform capabilities',
            featuresSubtitle: 'Innovative educational tools developed within the dissertation research',
            methodology: {
                title: 'Learning methodology',
                cards: [
                    {
                        title: 'Model and Structure',
                        desc: 'Model and structural organization of the methodology for improving the educational process based on the development and application of electronic educational resources',
                    },
                    {
                        title: 'Forms and Tools',
                        desc: 'Forms, methods, tools and stages of improving the educational process based on the application of electronic educational resources',
                    },
                    {
                        title: 'Pedagogical Conditions',
                        desc: 'Pedagogical conditions and methodological support for implementing improved learning in a digital educational environment',
                    },
                ],
            },
            cta: {
                title: 'Participate in the research!',
                desc: 'Try the adaptive digital learning ecosystem on the SmartEduLab platform and develop your cognitive independence',
                button: 'Register →',
            },
            footer: {
                copyright: '© 2026 SmartEduLab — Adaptive digital learning ecosystem (LMS)',
                subtitle: 'Based on the ADDIE model, cognitive ergonomics and Learning Analytics',
            },
        },
    },
};
